import {
  Badge,
  HStack,
  IconButton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import * as React from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { KYDPromoCode } from "@common/interfaces/KYDCart";
import { KYDTicketTypeAccessCode } from "@common/interfaces/KYDTicket";
import dayjs, { Dayjs } from "dayjs";

const formatDate = (date: Dayjs) => {
  return date.format("MMM D h:mmA");
};

const formatFromToDate = (tz: string, from?: string, to?: string) => {
  if (to && from) {
    const toDayjs = dayjs(to).tz(tz);
    const fromDayjs = dayjs(from).tz(tz);
    return (
      <>
        <Text>
          {formatDate(fromDayjs)} - {formatDate(toDayjs)}
        </Text>
      </>
    );
  }

  if (to) {
    const toDayjs = dayjs(to).tz(tz);
    return (
      <>
        <Text>before</Text>
        <Text>{formatDate(toDayjs)}</Text>
      </>
    );
  }

  if (from) {
    const fromDayjs = dayjs(from).tz(tz);
    return (
      <>
        <Text>after</Text>
        <Text>{formatDate(fromDayjs)}</Text>
      </>
    );
  }

  return <Text>Anytime</Text>;
};

export const AccessCodesTable = ({
  accessCodes,
  onEdit,
  loading,
  readOnly = false,
  timezone,
  isDisabled = false,
  ...props
}: {
  accessCodes: KYDTicketTypeAccessCode[];
  onEdit: (accessCode: KYDTicketTypeAccessCode) => void;
  readOnly: boolean;
  timezone?: string;
  isDisabled?: boolean;
  loading: any;
}) => (
  <Table {...props}>
    <Thead>
      <Tr>
        <Th>Code</Th>
        <Th>Ticket Types</Th>
        <Th>Valid</Th>
        <Th>Status</Th>
        <Th></Th>
      </Tr>
    </Thead>
    <Tbody>
      {accessCodes.map((accessCode: KYDTicketTypeAccessCode) => (
        <Tr key={accessCode.id}>
          <Td>
            <Text fontWeight="medium">{accessCode.code}</Text>
          </Td>
          <Td>
            <Text>{accessCode.ticket_type_ids.length}</Text>
          </Td>
          <Td>
            <Text fontSize="xs">
              {formatFromToDate(
                timezone,
                accessCode.valid_from,
                accessCode.valid_to
              )}
            </Text>
          </Td>
          <Td>
            <Badge colorScheme={accessCode.status === "OPEN" ? "green" : "red"}>
              {accessCode.status}
            </Badge>
          </Td>
          <Td>
            <HStack spacing="1">
              {readOnly ? null : (
                <IconButton
                  isDisabled={isDisabled || loading["blocking"]}
                  onClick={() => onEdit(accessCode)}
                  icon={<FiEdit2 fontSize="1.25rem" />}
                  variant="ghost"
                  aria-label="Edit member"
                />
              )}
            </HStack>
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
);
